(function () {
    var cfg = window.DOPLINE_ASYNC_SEARCH;
    if (!cfg) return;

    var MAX_POLLS  = 60;   // safety limit (~10 min at ~10s per upstream poll)
    var POLL_DELAY = 100;  // minimal gap — API does its own long-polling

    function sleep(ms) {
        return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    async function apiStart(search, lang) {
        var res = await fetch(cfg.apiStart, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept':       'application/json',
                'X-WP-Nonce':   cfg.restNonce || '',
            },
            body: JSON.stringify({ search: search, lang: lang }),
        });
        if (!res.ok) throw new Error('search/start: HTTP ' + res.status);
        var data = await res.json();
        if (!data.success) throw new Error(data.message || 'search/start failed');
        return data.data.search_hash;
    }

    async function apiPoll(hs, lang, renderedCount) {
        var url = new URL(cfg.apiPoll, window.location.origin);
        url.searchParams.set('search_hash', hs);
        url.searchParams.set('lang', lang);
        url.searchParams.set('rendered_count', String(renderedCount));
        if (cfg.checkin)  url.searchParams.set('checkin', cfg.checkin);
        if (cfg.checkout) url.searchParams.set('checkout', cfg.checkout);
        if (cfg.adults)   url.searchParams.set('adults', String(cfg.adults));
        if (cfg.children) url.searchParams.set('children', String(cfg.children));

        var res = await fetch(url.toString(), {
            headers: { 'Accept': 'application/json' },
        });
        if (!res.ok) throw new Error('search/poll: HTTP ' + res.status);
        var data = await res.json();
        if (!data.success) throw new Error(data.message || 'search/poll failed');
        return data.data;
    }

    function appendHtml(list, html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        while (tmp.firstChild) {
            list.appendChild(tmp.firstChild);
        }
    }

    function retryUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete('_hs');
        return url.toString();
    }

    function showError(container, msg) {
        container.innerHTML =
            '<div class="dl-card dopline-search-error">' +
                '<p class="dopline-search-error__msg">' + msg + '</p>' +
                '<a class="dl-btn dl-btn--accent" href="' + retryUrl() + '">Попробовать снова</a>' +
            '</div>';
    }

    /**
     * Render cards in visual chunks so the user sees them appearing
     * gradually even when all HTML arrives in a single API response.
     * Returns a Promise that resolves after the last chunk is in the DOM.
     */
    function renderChunked(list, html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = Array.from(tmp.children);
        if (!cards.length) return Promise.resolve();

        var CHUNK = 12;
        var delay = 100; // ms between chunks

        return new Promise(function (resolve) {
            var total = cards.length;
            var idx = 0;

            function nextChunk() {
                var end = Math.min(idx + CHUNK, total);
                for (var j = idx; j < end; j++) {
                    list.appendChild(cards[j]);
                }
                document.dispatchEvent(new CustomEvent('dopline:hotels-batch'));
                idx = end;
                if (idx < total) {
                    setTimeout(nextChunk, delay);
                } else {
                    resolve();
                }
            }

            nextChunk();
        });
    }

    function finishSearch(totalResult, list) {
        if (window.DoplineResultsMap) {
            window.DoplineResultsMap.ensureMap();
            window.DoplineResultsMap.setVisible(null);   // draw accumulated markers into cluster
            window.DoplineResultsMap.revealIfMarkers?.(cfg.destLabel || '');
        }

        requestAnimationFrame(function () {
            if (window.DoplineResultsMap) {
                window.DoplineResultsMap.reveal();
            }
            document.dispatchEvent(new CustomEvent('dopline:hotels-ready'));

            if (!totalResult && list) {
                list.innerHTML = '<div class="dl-card dopline-empty">По вашему запросу ничего не найдено.</div>';
            }
        });
    }

    async function run() {
        var container = document.querySelector('[data-search-async-container]');
        if (!container) return;

        var list = document.querySelector('[data-results-list]');
        var search = cfg.search || {};
        var lang   = cfg.lang   || 'ru';
        var renderedCount = 0;
        var firstBatch = true;
        var mapRevealed = false;

        try {
            var hs = await apiStart(search, lang);

            for (var i = 0; i < MAX_POLLS; i++) {
                await sleep(POLL_DELAY);
                var result = await apiPoll(hs, lang, renderedCount);

                // Render new hotel cards in visual chunks
                if (result.html && list) {
                    if (firstBatch) {
                        list.innerHTML = '';
                        firstBatch = false;
                    }
                    await renderChunked(list, result.html);
                }

                // Update found count
                if (result.total != null) {
                    var foundEl = document.querySelector('[data-found-count]');
                    if (foundEl) foundEl.textContent = String(result.total);
                }

                // Show map on first batch; subsequent markers go straight into the cluster
                if (result.markers && result.markers.length && window.DoplineResultsMap) {
                    if (!mapRevealed) {
                        window.DoplineResultsMap.ensureMap();
                        window.DoplineResultsMap.addMarkers(result.markers);
                        // ponytail: no fitBounds here — finishSearch fitBounds on all markers
                        window.DoplineResultsMap.revealIfMarkers?.(cfg.destLabel || '');
                        mapRevealed = window.DoplineResultsMap.hasMarkers?.() || false;
                    } else {
                        window.DoplineResultsMap.addMarkers(result.markers); // goes to cluster directly
                    }
                }

                renderedCount = result.rendered_count || renderedCount;

                if (result.is_completed) {
                    var url = new URL(window.location.href);
                    url.searchParams.set('_hs', hs);
                    history.pushState(null, '', url.toString());

                    finishSearch(result.total, list);
                    return;
                }
            }

            // Timeout: complete gracefully if we have partial results
            if (renderedCount > 0) {
                finishSearch(renderedCount, list);
            } else {
                showError(container, 'Поиск занял слишком много времени.');
            }
        } catch (err) {
            showError(container, 'Не удалось получить результаты поиска. Проверьте соединение и попробуйте ещё раз.');
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
